<div class="w-full inset-0 flex flex-col min-w-0 overflow-hidden">

    <mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent" (backdropClick)="onBackdropClicked()">

        <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">

            <!-- Main -->
            <div class="flex flex-col flex-auto">

                <!-- Header -->
                <div
                    class="flex flex-row items-center justify-start p-3 sm:py-6 md:px-6 border-b bg-card dark:bg-transparent">
                    <!-- Sidebar toggle button -->
                    <button 
                        *ngIf="!defaultView" 
                        mat-icon-button (click)="_fileManagerComponent.fileManagerDrawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>
                    <!-- Title -->
                    <div class="flex flex-col ml-3">
                        <div class="text-2xl font-extrabold tracking-tight leading-none" *appIsDisplayed="'showTrashPageTitle'">{{ 'Trash' | lpmLabel:'trashLocationLabel' }}</div>
                        <div class="flex items-center mt-0.5 font-medium text-secondary">
                            <ng-container *ngIf="items && items.length>0">
                                {{totalAssets.folders>0? totalAssets.folders : 0}} folders, {{totalAssets.files>0 ?
                                totalAssets.files: 0 }} files
                            </ng-container>
                            <!-- Breadcrumbs -->
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="ml-auto flex flex-row justify-end flex-grow">
                         <!-- Search Bar -->
                        <ng-container *ngIf="this.isWebComponent">
                            <div class="flex flex-col max-w-240" style="flex-grow: 1;">
                                <search class="mx-2" [config]="searchConfig" [loading]="isSearching" (keywordsChange)="onSearchKeywords($event)"
                                    (search)="onSearchApplied($event)" [appearance]="'basic'"></search>
                            </div>
                        </ng-container>
                        <!-- Sidebar toggle button -->
                        <button mat-button class="header-action-button-minimal" [color]="'primary'"
                            [matTooltip]="filterPanel.expanded ? 'Hide filters' : 'Show filters'"
                            (click)="toggleFilterPanel()" [ngClass]="{'button-active-dv': filterPanel.expanded}">
                            <mat-icon [svgIcon]="'mat_outline:filter_list'"></mat-icon>
                        </button>
                        <!-- View Stats -->
                        <button mat-button class="header-action-button-minimal" [color]="'primary'"
                            [matTooltip]="statsPanel.expanded ? 'Hide stats' : 'Show stats'"
                            [ngClass]="{'button-active-dv': statsPanel.expanded}" (click)=toggleStatsPanel()>
                            <mat-icon [svgIcon]="'mat_outline:insert_chart'"></mat-icon>
                        </button>
                        <!-- Delete ALL (icon-only button, shown when emptyTrashButtonWithLabel is not enabled) -->
                        <ng-template #emptyTrashIconOnlyBtn>
                            <button mat-button class="header-action-button-minimal" [color]="'warning'"
                                [matTooltip]="'Empty ' + ('Trash' | lpmLabel:'trashLocationLabel')" (click)="delete_all()">
                                <mat-icon [svgIcon]="'heroicons_outline:trash'" class="text-red-400"></mat-icon>
                            </button>
                        </ng-template>
                        <!-- Delete ALL -->
                        <button *appIsDisplayed="'emptyTrashButtonWithLabel'; else emptyTrashIconOnlyBtn" class="ms-1"
                            mat-stroked-button color="warn" [matTooltip]="'Empty ' + ('Trash' | lpmLabel:'trashLocationLabel')"
                            (click)="delete_all()">
                            <mat-icon class="icon-size-4"  [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                            <span class="ps-2">
                                Empty {{ 'Trash' | lpmLabel:'trashLocationLabel' }}
                            </span>
                        </button>
                    </div>
                </div>
                <!--Header Controls-->
                <div class="col file-manager-filter-panel text-md font-semibold 
                    text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 fade-transition">

                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel #filterPanel="matExpansionPanel" hideToggle
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'16px'">

                        </mat-expansion-panel-header>
                        <!--Panel of Search Options-->
                        <app-filter [labels]="labels" [FilterFields]="assetsFilterFields"
                            (onFilterChanges)="onFilterChange($event)"></app-filter>

                    </mat-expansion-panel>
                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel #multiItemSelectPanel="matExpansionPanel"
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5 file-manager-multi-item-actions file-grid z-10 sticky top-0 grid">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'0px'">

                        </mat-expansion-panel-header>
                        <!--Panel of Control Options for multiple files-->
                        <div class="row flex mt-2">
                            <div class="row flex justify-start items-center mr-2">
                                <button mat-icon-button matTooltip="Cancel bulk action" (click)="cancelBulkAction()">
                                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                                </button>
                            </div>
                            <div class="flex row items-center mr-6 ">
                                <span class="mr-2">{{selectedRows.length}}</span>
                                <span>selected</span>
                            </div>
                            <div class="row flex justify-start items-center justify-center">
                                <button mat-icon-button matTooltip="Restore" (click)="restore_multi()">
                                    <mat-icon class="bulk-actions-icon" svgIcon="mat_outline:restore"></mat-icon>
                                </button>
                                <button mat-icon-button matTooltip="Delete Forever" (click)="delete_multi(selectedRows)">
                                    <mat-icon class="bulk-actions-icon text-red-400" svgIcon="mat_outline:delete"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!--Show/Hide panel of stats -->
                    <mat-expansion-panel #statsPanel="matExpansionPanel" (opened)="isStatsPanelOpen = true"
                        (closed)="isStatsPanelOpen = false" class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'16px'">

                        </mat-expansion-panel-header>
                        <ng-container *ngIf="isStatsPanelOpen">
                            <dv-bar-trash></dv-bar-trash>
                        </ng-container>
                    </mat-expansion-panel>

                </div>
                <!-- Items list -->
                <ng-container *ngIf="items.length&& (folders.length > 0 || files.length > 0); else noItems">

                    <!-- Grid view -->
                    <ng-container *ngIf="viewMode === 'grid'"
                        class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                        <div class="fade-transition">
                            <ng-container *ngIf="items.length > 0 ">
                                <div class="grid">
                                    <!-- Header -->
                                    <div class="file-grid z-10 sticky top-0 grid gap-4 py-4 grid-header__record-row  shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5"
                                        matSort (matSortChange)="sortData($event)" >
                                        <!--Select All Checkbox -->
                                        <div class="col-1 absolute" >
                                            <mat-checkbox [color]="'primary'" class="mt-2" [checked]="isAllRowsSelected" (change)="toggleCheckAll()">
                                            </mat-checkbox>
                                        </div>
                                        <div class="col-1"></div>
                                        <div class="col-2" [mat-sort-header]="'FOLDER_NAME'" [start]="assetsSearch.sortDirection==='ASCENDING'?'desc':'asc'">Name</div>
                                        <div class="col-2 hidden sm:hidden md:block lg:block"
                                        [mat-sort-header]="'CREATED_DATE'"[start]="assetsSearch.sortDirection==='ASCENDING'?'desc':'asc'">
                                            Created
                                        </div>
                                        <div class="col-2 hidden sm:hidden md:block lg:block"
                                        [mat-sort-header]="'UPDATED_DATE'"[start]="assetsSearch.sortDirection==='ASCENDING'?'desc':'asc'">
                                        Updated
                                       </div>
                                        <div class="col-3 hidden sm:hidden md:hidden lg:block whitespace-nowrap"
                                            >
                                            Created By
                                        </div>
                                        <div class="col-3 hidden sm:hidden md:hidden lg:block whitespace-nowrap"
                                            >
                                            Updated By
                                        </div>
                                        <div class="col-3 hidden sm:hidden md:block lg:block"
                                            >
                                            File Size
                                        </div>
                                        <div class="col-6 hidden sm:hidden md:block lg:block"
                                            >
                                            Location
                                        </div>
                                    </div>
                                    <!-- Rows -->
                                    <!--TODO - determine if async/lazy loading pagination is needed
                                        *ngIf="(products$ | async) as products"-->
                                    <fuse-loading-bar *ngIf="isLoading || isSearching"></fuse-loading-bar>


                                    <ng-container *ngIf="!isLoading">
                                        <cdk-virtual-scroll-viewport #viewport [itemSize]="20"
                                            class="file-manager-viewport" [ngClass]="{
                                            'file-grid-adj-filter-open': filterPanel.expanded && !statsPanel.expanded && !multiItemSelectPanel.expanded,
                                            'file-grid-adj-stats-open': statsPanel.expanded && !filterPanel.expanded && !multiItemSelectPanel.expanded,
                                            'file-grid-adj-multi-open': multiItemSelectPanel.expanded && !statsPanel.expanded && !filterPanel.expanded,
                                            'file-grid-adj-both-open': statsPanel.expanded && filterPanel.expanded
                                          }">

                                            <div *ngFor="let asset of items; let i = index; trackBy:trackByFn"
                                                class="list-item-row">

                                                <!--Record Rows - Folders -->
                                                <ng-container *ngIf="asset.type === 'FOLDER'" class="list-item-row">
                                                    <!-- capture onRightClick event before browser and display context menu object-->
                                                    <div (mouseenter)="isBreadCrumbOpen=false" matRipple
                                                        [matRippleRadius]="radius" [matRippleColor]="color"
                                                        (contextmenu)="onRightClick($event, asset)" mat-table
                                                        class="file-grid grid items-center gap-4 py-3 grid-header__record-row border-b">
                                                        
                                                         <!-- Checkbox -->
                                                         <div class="flex items-center absolute">
                                                            <mat-checkbox [checked]="isSelectedRow(asset)" (change)="toggleRowCheck($event.checked,asset)" class="" #checkbox [color]="'primary'" [disableRipple]="true">
                                                            </mat-checkbox>
                                                        </div>

                                                        <!-- Image -->
                                                        <div class="col-1 flex items-center">
                                                            <div
                                                                class="folder-icon-div relative flex flex-0 items-center justify-center h-10 mr-6 rounded overflow-hidden">
                                                                <mat-icon class="folder-icon"
                                                                    [svgIcon]="util.getFileTypeImage('folder')"></mat-icon>
                                                            </div>
                                                        </div>

                                                        <!-- Name -->
                                                        <div
                                                            class="flex items-center font-medium truncate no-select cursor-pointer">
                                                            <div matTooltip="{{asset.name}}">
                                                                {{asset.name}}
                                                            </div>
                                                             <!-- Shared -->
                                                             <mat-icon
                                                             matTooltip="Shared"
                                                             matTooltipPosition="above"
                                                             *ngIf="asset.accessCount>1"
                                                             class="flex justify-center icon-size-4 ml-1 "
                                                             [svgIcon]="'heroicons_solid:users'">
                                                         </mat-icon>
                                                        </div>

                                                        

                                                        <!-- Created -->
                                                        <div class="col-2 hidden sm:hidden md:block lg:block">
                                                            {{asset.createdDate | date : 'MM/dd/yyyy'}}
                                                        </div>
                                                        <div class="col-2 hidden sm:hidden md:block lg:block">
                                                            {{asset.updatedDate | date : 'MM/dd/yyyy'}}
                                                        </div>

                                                        <!-- Uploaded By -->
                                                        <div class="col-3 text-center hidden sm:hidden md:hidden lg:block no-select"
                                                            [innerHTML]="asset['innerDiv']"
                                                            [matTooltip]="asset.createdBy | fullName">
                                                            {{asset?.createdBy | fullName}}
                                                        </div>


                                                        <div class="col-3 hidden sm:hidden md:hidden lg:block">
                                                            {{asset?.updatedBy | fullName}}
                                                          </div>

                                                        <!-- File Size -->
                                                        <div class="col-3 hidden sm:hidden md:block lg:block">
                                                        </div>
                                                        <!-- Original Location -->
                                                        <!--TODO - determine whether folderId can be used to display path and show users here
                                                    ex. '../Contacts/John Levesque/'-->
                                                        <div [routerLink]="getParentLink(asset.parent.id)"
                                                            cdkOverlayOrigin #trigger="cdkOverlayOrigin"
                                                            (mouseenter)="loadTooltipText(asset.id)"
                                                            class="col-6 hidden sm:hidden md:block lg:block text-primary cursor-pointer text-nowrap">
                                                            {{asset.parent.name}}
                                                        </div>
                                                        <ng-template
                                                            cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
                                                            [cdkConnectedOverlayHasBackdrop]="false"
                                                            (backdropClick)="isBreadCrumbOpen = false"
                                                            cdkConnectedOverlay (overlayOutsideHover)="hideBreadCrumb()"
                                                            [cdkConnectedOverlayOrigin]="trigger"
                                                            [cdkConnectedOverlayOpen]="isBreadCrumbOpen &&(hoveredAssetId == asset.id)">

                                                            <!--Asset Breadcrumb  -->
                                                            <nav (mouseleave)="hideBreadCrumb()"
                                                                class="flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
                                                                aria-label="Breadcrumb">
                                                                <div (mouseleave)="hideBreadCrumb()"
                                                                    class="flex items-center ms-3 space-x-2"
                                                                    *ngIf="assetPaths[asset.id]">
                                                                    <ng-container
                                                                        *ngFor="let path of assetPaths[asset.id]; let last = last;">
                                                                        <ng-container *ngIf="!last">
                                                                            <a *ngIf="path.name==='My Drive'"
                                                                                class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager']">{{path.name}}</a>
                                                                            <a *ngIf="path.name!=='My Drive'"
                                                                                class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager/folders/', path.id]">{{path.name}}</a>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="last">
                                                                            <div>{{path.name}}</div>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="!last">
                                                                            <div class="">/</div>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </div>

                                                                <div *ngIf="!assetPaths[asset.id]">
                                                                    Loading
                                                                </div>
                                                            </nav>
                                                        </ng-template>

                                                        <!-- Details button -->
                                                        <div class="row flex justify-end flex-nowrap">
                                                            <div class="row flex justify-end list-item-inline-actions flex-nowrap">
                                                                <button mat-icon-button matTooltip="Restore"
                                                                    (click)="stopPropagation($event); restore(asset.id)">
                                                                    <mat-icon class="icon-size-4"
                                                                        svgIcon="mat_outline:restore"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button matTooltip="Delete Forever"
                                                                    (click)="stopPropagation($event); delete(asset.id)">
                                                                    <mat-icon class="icon-size-4 text-red-400"
                                                                        svgIcon="mat_outline:delete"></mat-icon>
                                                                </button>
                                                            </div>
                                                            <button mat-icon-button matTooltip="Menu"
                                                                class="list-item-inline-action-menu"
                                                                (click)="stopPropagation($event);"
                                                                [matMenuTriggerFor]="fmItemActionMenu">
                                                                <mat-icon class="icon-size-4"
                                                                    [svgIcon]="'heroicons_solid:ellipsis-vertical'">
                                                                </mat-icon>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu="matMenu"
                                                                class="file-manager-item-action-menu">
                                                                <button mat-menu-item (click)="restore(asset.id)">
                                                                    <mat-icon class="icon-size-4"
                                                                        svgIcon="mat_outline:restore"></mat-icon>
                                                                    <span>Restore</span>
                                                                </button>

                                                                <!-- Divider -->
                                                                <div class="border-t"></div>
                                                                <button mat-menu-item (click)="delete(asset.id)">
                                                                    <mat-icon class="icon-size-4 text-red-400"
                                                                        svgIcon="mat_outline:delete"></mat-icon>
                                                                    <span>Delete Forever</span>
                                                                </button>
                                                            </mat-menu>
                                                        </div>
                                                    </div>
                                                </ng-container>

                                                <!--Record Rows - Files -->
                                                <ng-container *ngIf="asset.type === 'FILE'" class="list-item-row">
                                                    <!-- capture onRightClick event before browser and display context menu object-->
                                                    <div mat-table (mouseenter)="isBreadCrumbOpen=false"
                                                        (contextmenu)="onRightClick($event, asset)"
                                                        (click)="onRowClick(asset)"
                                                        [class.selected]="isSelected(asset)"
                                                        class="file-grid grid items-center relative gap-4 py-3 grid-header__record-row border-b">

                                                         <!-- Checkbox -->
                                                         <div class="flex items-center absolute">
                                                            <mat-checkbox  (click)="$event.stopPropagation()" [checked]="isSelectedRow(asset)" (change)="toggleRowCheck($event.checked,asset)" class="" #checkbox [color]="'primary'" [disableRipple]="true">
                                                            </mat-checkbox>
                                                        </div>

                                                        <!-- Image -->
                                                        <div class="flex items-center">
                                                            <div
                                                                class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                                                <mat-icon *ngIf="asset.locked" class="icon-size-4 absolute -left-3 text-orange-500 -top-1" svgIcon="mat_outline:lock"></mat-icon>
                                                                <mat-icon class="file-icon-size"
                                                                    [svgIcon]="util.getFileTypeImage(asset.extension)"></mat-icon>
                                                            </div>
                                                        </div>

                                                        <!-- Name -->
                                                        <div
                                                            class="flex items-center truncate no-select cursor-pointer file-manager-item-name-row">
                                                            <div matTooltip="{{asset.name}}"
                                                                class="file-manager-item-name">
                                                                {{asset.name}}
                                                            </div>
                                                            <mat-icon
                                                            matTooltip="Shared"
                                                            matTooltipPosition="above"
                                                            *ngIf="asset.accessCount>1"
                                                            class="flex justify-center icon-size-4 ml-1 "
                                                            [svgIcon]="'heroicons_solid:users'">
                                                        </mat-icon>
                                                        </div>

                                                        <!-- Created -->
                                                        <div class="no-select col-2 hidden sm:hidden md:block lg:block">
                                                            {{asset.createdDate | date : 'MM/dd/yyyy'}}
                                                        </div>

                                                        <div class="col-2 hidden sm:hidden md:block lg:block">
                                                            {{asset.updatedDate | date : 'MM/dd/yyyy'}}
                                                        </div>

                                                        <!-- Uploaded By -->
                                                        <div class="col-3 col-3 text-center hidden sm:hidden md:hidden lg:block no-select"
                                                            [innerHTML]="asset['innerDiv']"
                                                            [matTooltip]="asset.createdBy | fullName">
                                                            {{asset?.createdBy | fullName}}
                                                        </div>

                                                        <div class="col-3 hidden sm:hidden md:hidden lg:block">
                                                            {{asset?.updatedBy | fullName}}
                                                          </div>

                                                        <!-- File Size -->
                                                        <div class="no-select hidden sm:hidden md:block lg:block">
                                                            {{asset.size| fileSize}}
                                                        </div>
                                                        <!-- Original Location -->
                                                        <!--TODO - determine whether folderId can be used to display path and show users here 
                                                    ex. '../Contacts/John Levesque/'-->
                                                        <div [routerLink]="getParentLink(asset.parent.id)"
                                                            cdkOverlayOrigin #trigger="cdkOverlayOrigin"
                                                            (mouseenter)="loadTooltipText(asset.id)"
                                                            class="col-6 hidden sm:hidden md:block lg:block text-primary cursor-pointer text-nowrap">
                                                            {{asset.parent.name}}
                                                        </div>
                                                        <ng-template [cdkConnectedOverlayHasBackdrop]="false"
                                                            cdkConnectedOverlay (overlayOutsideHover)="hideBreadCrumb()"
                                                            [cdkConnectedOverlayOrigin]="trigger"
                                                            [cdkConnectedOverlayOpen]="isBreadCrumbOpen &&(hoveredAssetId == asset.id)">

                                                            <!--Asset Breadcrumb  -->
                                                            <nav (mouseleave)="hideBreadCrumb()"
                                                                class="flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
                                                                aria-label="Breadcrumb">
                                                                <div class="flex items-center ms-3 space-x-2"
                                                                    *ngIf="assetPaths[asset.id]">
                                                                    <ng-container
                                                                        *ngFor="let path of assetPaths[asset.id]; let last = last;">
                                                                        <ng-container *ngIf="!last">
                                                                            <a *ngIf="path.name==='My Drive'"
                                                                                class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager']">{{path.name}}</a>
                                                                            <a *ngIf="path.name!=='My Drive'"
                                                                                class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager/folders/', path.id]">{{path.name}}</a>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="last">
                                                                            <div>{{path.name}}</div>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="!last">
                                                                            <div class="">/</div>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </div>

                                                                <div *ngIf="!assetPaths[asset.id]">
                                                                    Loading
                                                                </div>
                                                            </nav>
                                                        </ng-template>

                                                        <!-- Details button -->
                                                        <div class="row flex justify-end flex-nowrap">
                                                            <div class="row flex justify-end list-item-inline-actions flex-nowrap">
                                                                <button mat-icon-button matTooltip="Restore"
                                                                    (click)="restore(asset?.id)">
                                                                    <mat-icon class="icon-size-4"
                                                                        svgIcon="mat_outline:restore"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button matTooltip="Delete Forever"
                                                                    (click)="delete(asset.id)">
                                                                    <mat-icon class="icon-size-4 text-red-400"
                                                                        svgIcon="mat_outline:delete"></mat-icon>
                                                                </button>
                                                            </div>
                                                            <button mat-icon-button matTooltip="Menu"
                                                                class="list-item-inline-action-menu"
                                                                [matMenuTriggerFor]="fmItemActionMenu">
                                                                <mat-icon class="icon-size-4"
                                                                    [svgIcon]="'heroicons_solid:ellipsis-vertical'">
                                                                </mat-icon>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu="matMenu"
                                                                class="file-manager-item-action-menu">
                                                                <button mat-menu-item (click)="restore(asset.id)">
                                                                    <mat-icon class="icon-size-4"
                                                                        svgIcon="mat_outline:restore"></mat-icon>
                                                                    <span>Restore</span>
                                                                </button>

                                                                <!-- Divider -->
                                                                <div class="border-t"></div>
                                                                <button mat-menu-item (click)="delete(asset?.id)">
                                                                    <mat-icon class="icon-size-4 text-red-400"
                                                                        svgIcon="mat_outline:delete"></mat-icon>
                                                                    <span>Delete Forever</span>
                                                                </button>
                                                            </mat-menu>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </cdk-virtual-scroll-viewport>



                                    </ng-container>


                                </div>
                                <!--Pagination-->
                                <mat-paginator [ngClass]="{'pointer-events-none': isLoading}" [length]="total"
                                    [pageIndex]="page.page" [pageSize]="page.size" [pageSizeOptions]="pageLimitList"
                                    (page)="onPageChanged($event)" [showFirstLastButtons]="true"></mat-paginator>
                            </ng-container>

                        </div>
                    </ng-container>
                    <!-- Grid view - END -->

                </ng-container>

                <!-- No items template -->
                <!--TODO - explore animation/transition; consider explicit linedashed drag and drop area-->
                <ng-template #noItems>
                    <div class="p-4 file-manager-viewport-empty">
                        <div  *ngIf="!isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <mat-icon
                          
                                class="icon-size-24"
                                [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                        </div>

                        <div  *ngIf="isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">Loading Data ... Please Wait</div>
                        </div>
                    </div>
                </ng-template>

            </div>

        </mat-drawer-content>

    </mat-drawer-container>

    <!-- a hidden div is created to set the position of appearance of the menu-->
    <div #fmActionMenuMainTrigger style="visibility: hidden; position: fixed;" [style.left.px]="menuTopLeftPosition.x"
        [style.top.px]="menuTopLeftPosition.y" [matMenuTriggerFor]="fmItemActionMenuItem"
        #fmItemActionMenuItemTrigger="matMenuTrigger">
    </div>
    <!--TODO - split functions for context action menu for file & folders-->
    <mat-menu #fmItemActionMenuItem="matMenu" class="file-manager-item-action-menu">
        <ng-template matMenuContent let-item="item">
            <!--TODO catch type of record from the file-manager.types.ts Item object-->
            <!--TODO hide 'download' and other options that are for Files only-->
            <button mat-menu-item (click)="restore(item.id)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:restore"></mat-icon>
                <span>Restore</span>
            </button>
            <button mat-menu-item  (click)="delete_multi(item.id)">
                <mat-icon class="icon-size-4 text-red-400" svgIcon="mat_outline:delete"></mat-icon>
                <span>Delete Forever</span>
            </button>
            <!-- Divider -->
        </ng-template>
    </mat-menu>
</div>